export default {
  INVITATION_PENDING: 'INVITATION_PENDING',
  ACCEPTED: 'ACCEPTED',
};
